(function () {

    var event = {
        //  "UIEvents", "MouseEvents", "MutationEvents", and "HTMLEvents"
        trigger: function (evName, evType) {

            var event;
            var eventType = evType || 'HTMLEvents';
            var el = document.body;

            if (document.createEvent) {
                event = document.createEvent(eventType);
                event.initEvent(evName, true, true);
            } else {
                event = document.createEventObject();
                event.eventType = evName;
            }

            event.eventName = evName;

            if (document.createEvent) {
                el.dispatchEvent(event);
            } else {
                el.fireEvent("on" + event.eventType, event);
            }
        },
        add: function (obj, type, fn) {
            if (obj.addEventListener) {
                obj.addEventListener(type, fn, false);
            }
            else {
                obj['e' + type + fn] = fn;
                obj[type + fn] = function () {
                    obj['e' + type + fn](window.event);
                };
                obj.attachEvent('on' + type, obj[type + fn]);
            }
        },
        remove: function (obj, type, fn) {
            if (obj.detachEvent) {
                obj.detachEvent('on' + type, obj[type + fn]);
                obj[type + fn] = null;
            } else {
                obj.removeEventListener(type, fn, false);
            }
        }
    };

    module.exports = event;

})();